import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { sensors } from '../services/api';
import './SensorList.css';

function SensorList() {
  const [sensorList, setSensorList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [newSensor, setNewSensor] = useState({
    sensorId: '',
    name: '',
    type: 'temperature',
    location: '',
    description: ''
  });
  const navigate = useNavigate();

  useEffect(() => {
    loadSensors();
  }, []);

  const loadSensors = async () => {
    try {
      const response = await sensors.getAll();
      setSensorList(response.data);
    } catch (error) {
      toast.error('Erro ao carregar sensores');
    } finally {
      setLoading(false);
    }
  };

  const handleCreateSensor = async (e) => {
    e.preventDefault();
    try {
      await sensors.create(newSensor);
      toast.success('Sensor criado com sucesso!');
      setShowModal(false);
      setNewSensor({
        sensorId: '',
        name: '',
        type: 'temperature',
        location: '',
        description: ''
      });
      loadSensors();
    } catch (error) {
      toast.error(error.response?.data?.error || 'Erro ao criar sensor');
    }
  };

  const handleDeleteSensor = async (id) => {
    if (window.confirm('Tem certeza que deseja deletar este sensor?')) {
      try {
        await sensors.delete(id);
        toast.success('Sensor deletado com sucesso!');
        loadSensors();
      } catch (error) {
        toast.error('Erro ao deletar sensor');
      }
    }
  };

  if (loading) return <div className="loading">Carregando...</div>;

  return (
    <div className="sensor-list-container">
      <div className="header">
        <h1>Meus Sensores</h1>
        <button onClick={() => setShowModal(true)} className="btn-primary">
          Novo Sensor
        </button>
      </div>

      {sensorList.length === 0 ? (
        <p className="empty-message">Nenhum sensor cadastrado</p>
      ) : (
        <div className="sensor-grid">
          {sensorList.map((sensor) => (
            <div key={sensor._id} className="sensor-card">
              <h3>{sensor.name}</h3>
              <p className="sensor-id">ID: {sensor.sensorId}</p>
              <p className="sensor-type">Tipo: {sensor.type}</p>
              {sensor.location && (
                <p className="sensor-location">Local: {sensor.location}</p>
              )}
              {sensor.description && (
                <p className="sensor-description">{sensor.description}</p>
              )}
              <div className="sensor-actions">
                <button
                  onClick={() => navigate(`/sensors/${sensor._id}`)}
                  className="btn-view"
                >
                  Ver Dados
                </button>
                <button
                  onClick={() => handleDeleteSensor(sensor._id)}
                  className="btn-delete"
                >
                  Deletar
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <h2>Novo Sensor</h2>
            <form onSubmit={handleCreateSensor}>
              <div className="form-group">
                <label>ID do Sensor *</label>
                <input
                  type="text"
                  value={newSensor.sensorId}
                  onChange={(e) => setNewSensor({...newSensor, sensorId: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>Nome *</label>
                <input
                  type="text"
                  value={newSensor.name}
                  onChange={(e) => setNewSensor({...newSensor, name: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>Tipo</label>
                <select
                  value={newSensor.type}
                  onChange={(e) => setNewSensor({...newSensor, type: e.target.value})}
                >
                  <option value="temperature">Temperatura</option>
                  <option value="humidity">Umidade</option>
                  <option value="pressure">Pressão</option>
                  <option value="motion">Movimento</option>
                  <option value="other">Outro</option>
                </select>
              </div>
              <div className="form-group">
                <label>Localização</label>
                <input
                  type="text"
                  value={newSensor.location}
                  onChange={(e) => setNewSensor({...newSensor, location: e.target.value})}
                />
              </div>
              <div className="form-group">
                <label>Descrição</label>
                <textarea
                  value={newSensor.description}
                  onChange={(e) => setNewSensor({...newSensor, description: e.target.value})}
                />
              </div>
              <div className="modal-actions">
                <button type="submit" className="btn-primary">Criar</button>
                <button type="button" onClick={() => setShowModal(false)} className="btn-secondary">
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default SensorList;
